import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "toolbar",
  id: "kt_toolbar"
}
const _hoisted_2 = {
  id: "kt_toolbar_container",
  class: "container d-flex flex-stack"
}
const _hoisted_3 = { class: "\n          page-title\n          d-flex\n          align-items-center\n          me-3\n          flex-wrap\n          mb-5 mb-lg-0\n          lh-1\n        " }
const _hoisted_4 = { class: "d-flex align-items-center text-dark fw-bolder my-1 fs-3" }
const _hoisted_5 = {
  key: 0,
  class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1"
}
const _hoisted_6 = { class: "breadcrumb-item pe-3" }
const _hoisted_7 = { class: "d-flex align-items-center py-1" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  href: "#",
  class: "btn btn-sm btn-flex btn-light btn-active-primary fw-bolder",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_10 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Filtros ")
const _hoisted_12 = {
  key: 1,
  href: "/docs",
  target: "_BLANK",
  class: "btn btn-sm btn-primary ms-4"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "bi bi-file-earmark-text" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "bi bi-plus" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "bi bi-plus" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Dropdown1 = _resolveComponent("Dropdown1")
  const _component_ELearningHelperModal = _resolveComponent("ELearningHelperModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1),
        (false && _ctx.breadcrumbs)
          ? (_openBlock(), _createBlock("ul", _hoisted_5, [
              _createVNode("li", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/dashboard",
                  class: "text-muted text-hover-primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translate("dashboard")), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_7, [
        (_ctx.isAuthenticated && _ctx.$route.name !== 'organization')
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              false
                ? (_openBlock(), _createBlock("a", _hoisted_9, [
                    _createVNode("span", _hoisted_10, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Text/Filter.svg" })
                    ]),
                    _hoisted_11
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Dropdown1)
            ]))
          : _createCommentVNode("", true),
        (
            _ctx.isAuthenticated &&
              (_ctx.$route.name === 'dashboard' || _ctx.$route.name === 'organization')
          )
          ? (_openBlock(), _createBlock("a", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.translate("planificationGuide")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAuthenticated && _ctx.$route.name === 'dashboard')
          ? (_openBlock(), _createBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn-sm btn-success ms-4",
              "data-bs-toggle": "modal",
              "data-bs-target": "#_app_organization_new_form_modal",
              id: "kt_toolbar_primary_button",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.createOrganization()), ["prevent"]))
            }, [
              _hoisted_14,
              _createTextVNode(" " + _toDisplayString(_ctx.translate("createOrganization")), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAuthenticated && _ctx.$route.name === 'organization')
          ? (_openBlock(), _createBlock("button", {
              key: 3,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openObjectiveModalOmi && _ctx.openObjectiveModalOmi(...args))),
              type: "button",
              class: "btn btn-success btn-sm ms-4",
              "data-bs-toggle": "modal",
              "data-bs-target": "#_app_objective_modal_omi"
            }, [
              _hoisted_15,
              _createTextVNode(" " + _toDisplayString(_ctx.translate("createObjective")), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ELearningHelperModal)
  ]))
}